import { useTranslations } from "use-intl";
import Text from "@/shared/typography/text";
import Input from "@/shared/form/input";
import { Space } from "@/shared/layout/space";
import { McpConnectionFragment } from "gql/graphql";
import { CopyButton } from "@/shared/form/button";

export function McpConnectionView({ url, configJson }: McpConnectionFragment) {
  const t = useTranslations("AI");

  return (
    <div className={"grid gap-5"}>
      <div className={"grid gap-2"}>
        <Text type={"body2"}>{t("MCP_SERVER_URL_DESCRIPTION")}</Text>

        <Space.Compact className={"!flex"}>
          <Input readOnly value={url} />
          <CopyButton value={url} />
        </Space.Compact>
      </div>

      <div className={"grid gap-2"}>
        <Text type={"body2"}>{t("MCP_CONFIG_DESCRIPTION")}</Text>

        <pre
          className={
            "m-0 p-3 rounded overflow-x-auto bg-[--ant-color-fill-quaternary]"
          }
        >
          {configJson}
        </pre>

        <div>
          <CopyButton value={configJson} />
        </div>
      </div>
    </div>
  );
}
